import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

import { IMAGE_DIR } from '@/shared/constants/linksApi'

export const CarouselCatalogItem = ({ imagesProduct }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const hasMultipleImages = imagesProduct.length > 1

  // Если только одно фото — просто показываем его
  if (!hasMultipleImages) {
    const singleImage = imagesProduct[0]
    return (
      <div className="CarouselCatalogItem w-full carousel-inner" style={!hasMultipleImages && {
        padding: 60,
        justifyContent: 'center',
      }}>
        <img
          src={IMAGE_DIR + singleImage.image}
          alt="item-product"
          className="w-full h-auto object-contain rounded-2xl"
        />
      </div>
    )
  }

  // Если фото несколько — показываем слайдеры
  return (
    <div className="CarouselCatalogItem w-full carousel-inner">
      {/* Основной слайдер */}
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        loop={true}
        navigation={true}
        spaceBetween={10}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mainSwiper rounded-2xl carousel-item"
      >
        {imagesProduct.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              src={IMAGE_DIR + item.image}
              alt="item-product"
              className="w-full h-auto object-contain"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Миниатюры */}
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={5}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="thumbsSwiper mt-3"
      >
        {imagesProduct.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              src={IMAGE_DIR + item.image}
              alt="thumb-product"
              className="cursor-pointer hover:opacity-80"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
